/** @jsx jsx */
import { jsx } from '@emotion/core';

import BundleConsoleBase from '../BundleConsoleBase';

type Log = {
  date: string;
  full_message: string;
  id: string;
  message: string;
};

type Props = {
  isLoading: boolean;
  logs: Array<Log>;
  onClickTestAgain: () => void;
};

function Console({ isLoading, logs, onClickTestAgain }: Props) {
  return (
    <BundleConsoleBase
      isLoading={isLoading}
      logs={logs.map(({ date, id, full_message, message }) => ({
        date,
        id,
        message: full_message,
        title: message,
      }))}
      onClickTestAgain={onClickTestAgain}
    />
  );
}

Console.defaultProps = {
  isLoading: false,
  logs: [],
};

export default Console;
